import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import {isTranslate} from 'shared/lib/lang';
import NoIncidentFree from 'shared/ui/icons/NoIncidentFree';
import Button from 'shared/ui/Button/Button/Button';

import Plug from '../Plug/Plug';

import styles from './PlugNoAccess.module.scss';

interface PlugNoAccessProps {
    size?: 'md' | 'sm';
}

const PlugNoAccess: React.FC<PlugNoAccessProps> = ({size}) => {
    const navigate = useNavigate();

    const handleChooseTariff = () => {
        navigate(isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS);
    };

    return (
        <Plug
            size={size}
            icon={<NoIncidentFree/>}
            title={t`Недоступно на вашем тарифе`}
            // eslint-disable-next-line max-len
            text={t`Дополнительные возможности доступны на тарифах от 100 ₽. Подключите расширенный план для отслеживания нужных данных.`}
            action={
                <Button
                    type="button"
                    className={styles.button}
                    onClick={handleChooseTariff}
                >
                    {t`Выбрать тариф`}
                </Button>
            }
        />
    );
};

export default PlugNoAccess;
